'use strict';
import { LogHelper } from 'com-gyf-webcore-loghelper';

import {
    ABMMODELOS_ACTUALIZAR_DATOS_CONFIRMACION,
    ABMMODELOS_ACTUALIZAR_MENSAJE_RENGLONES_IGUALES,
    ABMMODELOS_ACTUALIZAR_RENGLONES,
    ABMMODELOS_ACTUALIZAR_CRITERIOS,
    ABMMODELOS_ACTUALIZAR_DATOSEXCEL,
    ABMMODELOS_ACTUALIZAR_OPCION_ELEGIDA,
    ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR,
    ABMMODELOS_ACTUALIZAR_VALORES_MODAL_ALTA_EDICION_RENGLON,
    ABMMODELOS_ACTUALIZAR_VALORES_MODAL_COPIAR_RENGLON,
    ABMMODELOS_AGREGAR_RENGLON,
    ABMMODELOS_AGREGAR_ELIMINAR_RENGLON_CONTABLE,
    ABMMODELOS_AGREGAR_QUITAR_OPCIONES_SELECTORES,
    ABMMODELOS_CAMBIAR_CHECK,
    ABMMODELOS_CAMBIAR_CHECK_PANTALLA_PRINCIPAL,
    ABMMODELOS_ACTUALIZAR_PANTALLA_ABMMODELOS,
    ABMMODELOS_CAMBIAR_RENGLON_BOTON_DESPLEGABLE,
    ABMMODELOS_CAMBIAR_VALOR_INPUT,
    ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR,
    ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR_POR_NOMBRE,
    ABMMODELOS_CARGAR_CAMPO_IMPORTE,
    ABMMODELOS_CARGAR_COMBOS_CRITERIOS_CONTABLES,
    ABMMODELOS_CARGAR_CUENTAS_CONTABLES,
    ABMMODELOS_CARGAR_PERMISOS_USUARIO,
    ABMMODELOS_CARGAR_CUENTAS_CONTABLES_FILTRADAS,
    ABMMODELOS_FILTRAR_CUENTAS,
    ABMMODELOS_FILTRAR_CUENTAS_COPIAR_RENGLON,
    ABMMODELOS_FILTRAR_INDICADORES_INTERFAZ,
    ABMMODELOS_FILTRAR_MODELOS,
    ABMMODELOS_FILTRAR_MODELOS_IMPORTAR,
    ABMMODELOS_GUARDAR_CANTIDADES_REEMPLAZADAS,
    ABMMODELOS_GUARDAR_DATOS_SAGA_REEMPLAZAR_CUENTA,
    ABMMODELOS_GUARDAR_QUITAR_MODELO_SELECCIONADO,
    ABMMODELOS_GUARDAR_VALOR_INPUT_SELECCIONADO,
    ABMMODELOS_IMPORTAR_MODELO,
    ABMMODELOS_INPUT_ACTIVO,
    ABMMODELOS_INPUT_ACTIVO_BUSCADOR_MODELOS,
    ABMMODELOS_MOSTRAR_RESULTADOS_INDICADOR_INTERFAZ,
    ABMMODELOS_MOSTRAR_INPUT_IMPORTAR_MODELOS,
    ABMMODELOS_MOSTRAR_MODAL,
    ABMMODELOS_MOSTRAR_MODAL_MENSAJE_RESULTADO,
    ABMMODELOS_MOSTRAR_RESULTADOS_IMPORTAR_MODELOS,
    ABMMODELOS_MOSTRAR_SPINNER,
    ABMMODELOS_OCULTAR_BOTON_VERMAS,
    ABMMODELOS_REINICIAR_VALORES_MODAL,
    ABMMODELOS_RENGLON_EDICION,
    ABMMODELOS_SELECCIONAR_OPCION_COMBO,
    ABMMODELOS_TIPOS_MOVIMIENTO,
    ABMMODELOS_LIMPIEZA_CUENTA_SELECCIONADA,
    ABMMODELOS_SELECCIONAR_RB,
    ABMMODELOS_VALIDAR_FORMULARIO,
    INITIAL_STATE,
    ROUTE_TO_MODELOS_CONTABLES
} from '../../Screens/ModelosContables/actions/ABMModelosActions';

const initialState = {
    redirect: {                                             //Objeto que contiene la información necesaria para redireccionarse entre diferentes páginas de la funcionalidad de Modelos Contables.
        shouldRedirect: false,                                  //Flag que determina si se debe redireccionar a la página indicada.
        to: null                                                //Información de la URL de la página a donde se hará la redirección.
    },
    modalReemplazarCuentasContables: false,                 //Flag utilizado para mostrar u ocultar el modal de "Reemplazar Cuentas Contables".
    modalAltaEdicionRenglonContable: false,                 //Flag utilizado para mostrar u ocultar el modal de "Alta/Edicion de Renglón Contables".
    modalCopiarRenglonContable: false,                      //Flag utilizado para mostrar u ocultar el modal de "Copiar renglón contable".
    modalConfirmarBorrarRenglon: false,                     //Flag utilizado para mostrar u ocultar el modal de "Confirmación de Eliminación de Renglón contable".
    modalResultadoReemplazarCuentasContables: false,        //Flag utilizado para mostrar u ocultar el modal de "Resultado de reemplazdo de cuentas contables".
    modalConfirmarAbandonoABMModelos: false,                //Flag utilizado para mostrar u ocultar el modal de "Confirmación de salida de pantalla ABM de Modelos para un modelo no confirmado".
    modalMensajeResultado: "",                              //Variable que guardará un mensaje resultante de alguna operación y se mostrará en pantalla
    redireccionarPantallaPrincipal: false,                  //Flag utilizado para verificar si redireccionar a la pantalla principal de "Modelos Contables" una vez realizado el guardado de modelo.
    opcionElegida: "C",
    nroRenglon: undefined,                                  //Variable que guarda el número de renglón que se desea eliminar, luego de confirmar la eliminación a través del modal de "modalConfirmarBorrarRenglon"
    seAgregaRenglon: undefined,                             //Flag que determina si el renglón se está agregando o eliminando, luego de confirmar la eliminación a través del modal de "modalConfirmarBorrarRenglon"
    mostrarSpinnerABMModelos: false,                        //Flag utilizado para mostrar u ocultar el spinner de carga.
    mostrarSpinnerModales: false,                           //Flag utilizado para mostrar u ocultar el spinner de carga del modal de "Reemplazar Cuentas Contables".
    cuentasContables: [],                                   //Array original que contiene toda la información de las cuentas contables.
    modelosContables: [],                                   //Array original que contiene toda la información de los modelos contables.
    modelosContablesActivos: [],                            //Array original que contiene todos los modelos contables activos.
    modeloEdicion: {},                                      //Variable que guarda el código de modelo seleccionado desde la grilla de "Modelos Contables", si se trata de un nuevo modelo, el valor sera un objeto vacio.
    permisosUsuario: [],                                    //Array con los permisos sobre el Feature de CONTABILIDAD que tiene el usuario logeado.
    datosPantalla: [],                                      //Objeto que guardará los datos principales a mostrar en la pantalla de ABM Modelos (se envían los datos de los renglones junto con los datos principales).
    datosRenglones: [],                                     //Array que guarda los datos referidos a los renglones.
    criteriosRenglon: undefined,                            //Objeto que guarda los datos referidos a criterios contables.
    sugerenciaModelo: undefined,                            //Objeto que guarda la sugerencia de modelo a visualizar como placeholder en el input de "Código de modelo" de la obtención de datos.
    marcasActivas: [],                                      //Array de las marcas activas de la obtención de datos de marcas.
    sucursalesActivas: [],                                  //Array de las sucursales activas de la obtención de datos de sucursales.
    monedasActivas: [],                                     //Array de las monedas activas de la obtención de datos de monedas.
    indicadoresInterfazActivos: [],                         //Array de los indicadores de interfaz activos de la obtención de datos de indicadores de interfaz.
    registroDesplegado: null,                               //Variable que guarda el número de renglón al cual se le desplegará los datos adicionales con los criterios.
    datosRenglonesExcel: [],                                //Array que contendrá los datos ACTUALES de los renglones en pantalla y a través del cual se realizará la exportación a excel.
    seImportaModelo: false,                                 //Flag a través del cual se evalúa si mostrar el buscador de modelos para importar o no, false no se muestra y true se muestra.
    cantidadRenglones: "",                                  //Variable que guarda la cantidad de renglones actualizados con la cuenta contable reemplazada a partir del modal de "Reemplazar Cuentas Contables".
    cantidadModelos: "",                                    //Variable que guarda la cantidad de modelos actualizados con la cuenta contable reemplazada a partir del modal de "Reemplazar Cuentas Contables".
    datosMakerChecker : [],                                 //Variable que guarda los datos de la cuenta contable reemplazada a partir del modal de "Maker Checker".  
    sagaId: undefined,                                      //Variable que guarda el sagaId de la saga ejecutada por el modal "Reemplazar Cuentas Contables".
    referenciaRenglonCopia: 0,                              //Variable en donde se guardará números de referencia para asociar la copia de renglones con los criterios copiados, si los tuviere.
    tiposMovimiento: [],
    renglonEdicion: {},                                     //Objeto que guarda los datos de un renglon en caso de tratarse de una edicion de renglon, caso contrario permanecera vacio.
    mensajeValidacionRenglonesIguales: "",                  //Variable que aloja el mensaje respectivo a la validación de renglones iguales ejecutada durante la carga inicial de la pantalla de ABM de Modelos, Alta/Edición de Renglones y Copia de renglones.
    inputsABMModelos: {                                     //Objeto contenedor creado para guardar la información utilizada en diferentes inputs, agrupados por nombre de modal.
        inputCodigoModelo: "",                                  //Variable que guarda el input ingresado por el usuario para el input de "Código de modelo".
        inputNombreModelo: "",                                  //Variable que guarda el input ingresado por el usuario para el input de "Nombre de modelo".
        inputDiasDiferimiento: "0",                              //Variable que guarda el input ingresado por el usuario para el input de "Días de diferimiento".
        inputImportarModelo: "",                                //Variable que guarda el input ingresado por el usuario para el input de búsqueda de modelos a importar.
        modeloSeleccionadoImportar: null,                       //Guarda el valor del código del modelo seleccionado del dropdown de modelos a importar.
        descripcionModeloSeleccionadoImportar: "",              //Valor que guarda la descripción (código + descripción) del modelo seleccionado del dropdown de modelos a importar.
        mostrarResultadosImportarModelo: false,                 //Flag que determina la visualización del dropdown con las opciones posibles a seleccionar para la importación de modelos.
        modelosFiltradosImportarModelo: [],                     //Array que guarda las opciones a seleccionar para la importación de modelos filtradas a través de lo ingresado en el input del buscador.
        inputIndicadorInterfaz: "",                             //Variable que guarda el input ingresado por el usuario para el input de "Indicadores de Interfaz".
        mostrarResultadosIndicadorInterfaz: false,              //Flag que determina la visualización del dropdown con las opciones posibles a seleccionar para los indicadores de interfaz.
        indicadorInterfazSeleccionado: null,                    //Guarda el valor del Id del indicador de interfaz seleccionado del dropdown del buscador de indicadores de interfaz.
        descripcionIndicadorInterfazSeleccionado: "",           //Valor que guarda la descripción (código + descripción) del indicador de interfaz seleccionado del dropdown del buscador de indicadores de interfaz.
        indicadorInterfazFiltrados: [],                         //Array que guarda las opciones a seleccionar para los indicadores de interfaz filtrados a través de lo ingresado en el input del buscador.
        modalReemplazarCuentasContables: {                      //Objeto contenedor que guarda la información de los inputs del modal de "Reemplazar Cuentas Contables".
            inputReemplazarCuenta: "",                              //Variable que guarda el input ingresado por el usuario para el input de "Reemplazar la cuenta contable".
            cuentasContablesFiltradasReemplazarCuenta: [],          //Array que contiene las cuentas contables filtradas a través del input de "Reemplazar la cuenta contable" y el cual se mostrará en el dropdown de dicho input.
            inputReemplazarCon: "",                                 //Variable que guarda el input ingresado por el usuario para el input de "por la cuenta contable".
            cuentasContablesFiltradasReemplazarCon: [],             //Array que contiene las cuentas contables filtradas a través del input de "por la cuenta contable" y el cual se mostrará en el dropdown de dicho input.
            inputActivo: "",                                        //Variable que guardará el nombre del input ("inputReemplazarCuenta", "inputReemplazarCon" o "inputModelos") que actualmente esté activo, para determinar qué dropdown se deberá mostrar al momento de hacer click en el input.
            cuentasSeleccionadas: {                                 //Objeto contenedor que guarda la información de las cuentas seleccionadas en los diferentes inputs de "inputReemplazarCuenta" y "inputReemplazarCon".
                inputReemplazarCuenta: "",                              //Variable que guarda el código de la cuenta seleccionada en el input de "inputReemplazarCuenta".
                inputReemplazarCon: ""                                  //Variable que guarda el código de la cuenta seleccionada en el input de "inputReemplazarCon".
            },
            inputModelos: "",                                       //Variable que guarda el input ingresado por el usuario para el input del buscador de modelos.
            modelosSeleccionados: [],                               //Array donde se guardan los modelos seleccionados desde el buscador de modelos para ir listándolos posteriormente debajo del mismo en forma de etiquetas.
            modelosContablesFiltrados: [],                          //Array que contiene los modelos filtrados a través del input del buscador de modelos y el cual se mostrará en el dropdown de dicho input.
            mostrarVerMas: true                                     //Flag que determina la visualización del botón "Ver más" al momento de seleccionar más de 9 modelos del buscador de modelos. Al clickear el botón de "Ver más" se cambia el valor a false y no se volverá a mostrar el botón.
        },
        modalAltaEdicionRenglonContable: {                          //Objeto contenedor que guarda la información de los inputs del modal de "Alta/Edicion de Renglón Contables".
            inputCuentaContable: "",   
            inputActivo: "", 
            inputDescripcion : "",                                    //Variable que guarda el input ingresado por el usuario para el input de "Descripción".
            inputReferenciaRenglon: "",
            cuentasContablesFiltradas: [], 
            cuentasSeleccionadas:{          
                inputCuentaContable:"",
            },
        },
            modalCopiarRenglonContable: {                           //Objeto contenedor que guarda la información de los inputs del modal de "Copiar renglón contable".
            inputCuentaContable: "",                                //Variable que guarda el input ingresado por el usuario para el input de "Cuentas Contables".
            cuentasContablesFiltradas: [],                          //Array que contiene las cuentas contables filtradas y el cual se mostrará en el dropdown de dicho input.
            inputActivo: "",                                        //Variable que guardará el nombre del input ("inputCuentaContable") cuando éste esté activo, para determinar si se visualiza o no el dropdown.
            cuentasSeleccionadas: {                                 //Objeto contenedor que guarda la información de las cuentas seleccionadas en los diferentes inputs de "inputReemplazarCuenta" y "inputReemplazarCon".
                inputCuentaContable: "",                                //Variable que guarda el código de la cuenta seleccionada en el input de "inputCuentaContable".
            },
            inputNumeroRenglon: "",                                 //Variable que guarda el input ingresado por el usuario para el input del radio button de "En la posición N:".
            ultimoNumeroRenglon: undefined,                         //Variable que guarda el último número de renglón del modelo actual.
            renglon: undefined,                                     //Objeto que contiene toda la información del renglón a copiar.
            criterios: undefined                                    //Objeto que contiene toda la información de los criterios asociados al renglón a copiar.
        }
    },
    checksABMModelos: {                                     //Objeto contenedor creado para guardar la información utilizada en diferentes checkboxes, agrupados por nombre de modal.
        checkModeloHabilitado: true,                            //Flag que determina si el checkbox de "Habilitado" se deberá tildar o no. Por defecto queda tildado para un alta de un modelo.
        checkAperturaPorSucursal: false,                        //Flag que determina si el checkbox de "Apertura por Sucursal" se deberá tildar o no.
        checkAperturaPorSocio: false,                           //Flag que determina si el checkbox de "Apertura por socio" se deberá tildar o no.
        checkConfirmacionAutomatica: false,                     //Flag que determina si el checkbox de "Confirmación automática" se deberá tildar o no.
        checkRequiereReverso: false,                            //Flag que determina si el checkbox de "Requiere reverso" se deberá tildar o no.
        modalReemplazarCuentasContables: {                      //Objeto contenedor que guarda la información de los checkboxes del modal de "Reemplazar Cuentas Contables".
            checkReemplazarEnOtrosModelos: false                    //Flag que determina si el checkbox de "Reemplazar también en otros modelos" se deberá tildar o no.
        }
    },
    radioButtonsABMModelos: {                               //Objeto contenedor creado para guardar la información utilizada en diferentes radio buttons.
        rbMarca: "VISA",                                        //Guarda el valor del radioButton de la marca seleccionada (el valor es el código de la parametria de Administradoras)
        rbMoneda: "PESO",                                       //Guarda el valor del radioButton de la moneda seleccionada (el valor es el código de la parametria de Monedas)
        rbTipoSucursal: 1,                                      //Guarda el valor del radioButton del tipo de Sucursal seleccionado (1 - Sucursal del Movimiento / 2 - Sucursal de Radicación de la Cuenta)
        rbTipoConsolidacion: 1,                                 //Guarda el valor del radioButton del tipo de consolidación seleccionado (1 - Consolidación por Renglón / 2 - Consolidación por Cuenta Contable y Tipo de Operación (D o H) / 3 - Consolidación por Cuenta Contable.)
        modalCopiarRenglonContable: {                           //Objeto contenedor del modal de "Copiar renglón contable" que guarda la información utilizada en los radio buttons.
            rbUbicacionRenglon: 0,                                  //Guarda el valor del radioButton de la ubicación del renglón seleccionada (0 - Debajo del renglón seleccionado / 1 - Como último renglón del modelo / 2 - En la posición N:)
            rbTipoOperacion: "D",                                   //Guarda el valor del radioButton del tipo de operación seleccionado (D - Débito / C - Crédito)
            rbSignoImporte: "A",                                    //Guarda el valor del radioButton del signo del importe seleccionado (A - Ambos / N - Negativo / P - Positivo)
            mostrarSignoAmbos: true                                 //Flag que determina si debe ocultarse el radioButton asociado al valor "Ambos" del Signo del importe, determinado si el renglón a copiar es de tipo "Balanceo automático"
        },
        modalAltaEdicionRenglonContable:{
            rbTipoApertura: 1,                                      //Guarda el valor del radioButton del tipo de apertura seleccionado (1- Sin Apertura. 2- Socio. 3- Movimiento)
            rbTipoRenglon: 1,                                       //Guarda el valor del radioButton del tipo de renglón seleccionado (1- Automático. 2- Manual. 3- Balanceo Automático)
            rbReferenciaRenglon: 0, 
            rbTipoOperacion: 1,
            rbMonedaSalida: "P",
            rbSignoImporte: "A"
        }
    },
    combosABMModelos: {                                     //Objeto contenedor creado para guardar la información utilizada en diferentes combos.
        comboSucursal: 0,                               //Guarda el valor del Id de la Sucursal seleccionada.
        modalAltaEdicionRenglonContable: {             //Objeto contenedor que guarda la información de los inputs del modal de "Alta/Edicion de Renglón Contables".
            comboCentroCostoSeleccionado:"0",
            comboTipoMovimientoSeleccionado:"",
            comboCampoImporteSeleccionado:"",
            comboTiposMovimientos:[],
            contenedorCombosCriteriosContables:[]
    }                                     
    },
    errorValidacion: {                                      //Objeto contenedor creado para guardar la información de errores de validación de componentes que deban validarse.
        inputIndicadorInterfaz: "",                             //Variable que guarda (en el caso de haber error) un mensaje a mostrar para el input de "inputIndicadorInterfaz".
        inputCodigoModelo: "",                                  //Variable que guarda (en el caso de haber error) un mensaje a mostrar para el input de "Código de modelo".
        inputNombreModelo: "",                                  //Variable que guarda (en el caso de haber error) un mensaje a mostrar para el input de "Nombre de modelo".
        inputDiasDiferimiento: "",                              //Variable que guarda (en el caso de haber error) un mensaje a mostrar para el input de "Días de diferimiento".
        seccionRenglones: "",                                   //Variable que guarda (en el caso de haber error) un mensaje a mostrar para las validaciones realizadas para la sección de renglones contables.
        modalReemplazarCuentasContables: "",                    //Variable que guarda (en el caso de haber error) un mensaje a mostrar en el modal de "Reemplazar Cuentas Contables".
        modalResultadoReemplazarCuentasContables: false,        //Flag que indica si hubo un error en la transacción realizada en el modal de "Reemplazar Cuentas Contables".
        modalCopiarRenglonContable: {                          //Objeto que guarda (en el caso de haber error) un mensaje a mostrar en el modal de "Copiar renglón contable".
            inputNumeroRenglon: "",                                //Variable que guarda (en el caso de haber error) un mensaje a mostrar en el input del radio button de "En la posición N:".
            inputCuentaContable: ""                                //Variable que guarda (en el caso de haber error) un mensaje a mostrar en el input de la cuenta contable.
        },
        modalAltaEdicionRenglonContable: {             //Objeto contenedor que guarda la información de los inputs del modal de "Alta/Edicion de Renglón Contables".
            inputDescripcion : "",    //Crear validacion por vacio                             
            inputReferenciaRenglon: "", // si referencia es "otra" crear validacion por vacio         
            inputCuentaContable:"", // Crear validacion por vacio       
            combosCriteriosContables:"" //Crear validacion por vacio
        }  
    }
}

function abmModelos(state = initialState, action) {
    LogHelper.In(abmModelos.name, state, action);
    let result;

    switch (action.type) {
        case INITIAL_STATE: {
            state = initialState;


            result = {
                ...state
            }
        }
        break;


        case ABMMODELOS_MOSTRAR_MODAL: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let inputs = JSON.parse(JSON.stringify(state.inputsABMModelos));
            let radioButtons = JSON.parse(JSON.stringify(state.radioButtonsABMModelos));
            let datosRenglones = state.datosRenglones ? JSON.parse(JSON.stringify(state.datosRenglones)) : [];

            let cuentasContablesFiltradas = state.cuentasContables;
            let cuentasContables = action.nombreModal == "modalReemplazarCuentasContables" || action.nombreModal == "modalAltaEdicionRenglonContable"? 
                                        state.cuentasContables 
                                    :  
                                        state.inputsABMModelos.modalReemplazarCuentasContables.cuentasContablesFiltradas;
            
            inputs.modalReemplazarCuentasContables.cuentasContablesFiltradasReemplazarCuenta = cuentasContables;
            inputs.modalReemplazarCuentasContables.cuentasContablesFiltradasReemplazarCon = cuentasContables;
            //Filtar las cuentas contables segun los radiobuttons elegidos para modalAltaEdicionRenglonContable
            if(action.nombreModal == "modalAltaEdicionRenglonContable"){
                radioButtons.modalAltaEdicionRenglonContable.rbMonedaSalida == "P" || radioButtons.modalAltaEdicionRenglonContable.rbMonedaSalida == 1
                ?
                cuentasContablesFiltradas = cuentasContablesFiltradas.filter((cuenta) => cuenta.MonedaId == 0 || cuenta.MonedaId == 1)
                    :
                cuentasContablesFiltradas = cuentasContablesFiltradas.filter((cuenta) => cuenta.MonedaId == 0 || cuenta.MonedaId == 2)

                if(radioButtons.modalAltaEdicionRenglonContable.rbTipoOperacion == 1){cuentasContablesFiltradas = cuentasContablesFiltradas.filter((cuenta) => cuenta.TipoOperacion == 1 || cuenta.TipoOperacion == 0)}
            
                if(radioButtons.modalAltaEdicionRenglonContable.rbTipoOperacion == 2){cuentasContablesFiltradas = cuentasContablesFiltradas.filter((cuenta) => cuenta.TipoOperacion == 2 || cuenta.TipoOperacion == 0)}

            inputs.modalAltaEdicionRenglonContable.cuentasContablesFiltradas = cuentasContablesFiltradas;
            }
            inputs.modalCopiarRenglonContable.ultimoNumeroRenglon = datosRenglones ? Math.max(...datosRenglones.filter(renglon => !renglon.DeleteInstance).map(renglon => renglon.NroRenglon)) : 0;

            result = {
                ...state,
                [action.nombreModal]: action.mostrarModal,
                inputsABMModelos: inputs,
                nroRenglon: action.nroRenglon,
                seAgregaRenglon: action.seAgregaRenglon
            }
        }
        break;


        case ABMMODELOS_CARGAR_CUENTAS_CONTABLES: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let inputs = JSON.parse(JSON.stringify(state.inputsABMModelos));
            let checks = JSON.parse(JSON.stringify(state.checksABMModelos));
            let radioButtons = JSON.parse(JSON.stringify(state.radioButtonsABMModelos));
            let combos = JSON.parse(JSON.stringify(state.combosABMModelos));

            //Quito el modelo seleccionado como edición para que no se visualice en el buscador de modelos
            inputs.modalReemplazarCuentasContables.modelosContablesFiltrados = action.datosPantalla.modelosActivos.filter(mc => mc.Codigo != action.datosPantalla.modeloEdicion);

            inputs.modelosFiltradosImportarModelo = action.datosPantalla.modelosActivos.filter(mc => mc.Codigo != action.datosPantalla.modeloEdicion);
            inputs.indicadorInterfazFiltrados = JSON.parse(JSON.stringify(action.datosPantalla.indicadoresInterfazActivos));
            inputs.inputCodigoModelo     = action.datosPantalla.codigoModeloEdicion     ? action.datosPantalla.codigoModeloEdicion     : inputs.inputCodigoModelo;
            inputs.inputNombreModelo     = action.datosPantalla.nombreModeloEdicion     ? action.datosPantalla.nombreModeloEdicion     : inputs.inputNombreModelo;
            inputs.inputDiasDiferimiento = action.datosPantalla.diasDiferimientoEdicion ? action.datosPantalla.diasDiferimientoEdicion : inputs.inputDiasDiferimiento;
            
            inputs.inputIndicadorInterfaz = action.datosPantalla.indicadorInterfazEdicion ? action.datosPantalla.indicadorInterfazEdicion : "";
            inputs.indicadorInterfazSeleccionado = action.datosPantalla.indicadorInterfazEdicion ? action.datosPantalla.indicadorInterfazEdicion : inputs.indicadorInterfazSeleccionado;
            inputs.descripcionIndicadorInterfazSeleccionado = action.datosPantalla.descripcionIndicadorInterfazSeleccionado ? action.datosPantalla.descripcionIndicadorInterfazSeleccionado : inputs.descripcionIndicadorInterfazSeleccionado;

            inputs.modalCopiarRenglonContable.ultimoNumeroRenglon = action.datosPantalla.datosPantallaEdicion.datosPantalla ? Math.max(...action.datosPantalla.datosPantallaEdicion.datosPantalla.map(renglon => renglon.NroRenglon)) : 0;

            //Si se trata de una edición de un modelo se determina el valor del check de "Habilitado" si dicho modelo está dado de baja o no. Si se trata de un alta el check por defecto estará tildado.
            checks.checkModeloHabilitado = action.datosPantalla.modeloEdicion ? Boolean(!action.datosPantalla.datosPantallaEdicion?.datosPantalla[0]?.FechaBaja)  : checks.checkModeloHabilitado;
            //Si se trata de un alta de modelo, dejo por defecto el valor del check de "Reemplazar en otros modelos" activo.
            checks.modalReemplazarCuentasContables.checkReemplazarEnOtrosModelos = !action.datosPantalla.modeloEdicion;

            checks.checkAperturaPorSucursal = action.datosPantalla.abreSucursal ? Boolean(action.datosPantalla.abreSucursal) : checks.checkAperturaPorSucursal;
            checks.checkAperturaPorSocio = action.datosPantalla.abreSocio ? Boolean(action.datosPantalla.abreSocio) : checks.checkAperturaPorSocio;
            checks.checkConfirmacionAutomatica = action.datosPantalla.confirmacionAutomatica ? Boolean(action.datosPantalla.confirmacionAutomatica) : checks.checkConfirmacionAutomatica;
            checks.checkRequiereReverso = action.datosPantalla.requiereReverso ? Boolean(action.datosPantalla.requiereReverso) : checks.checkRequiereReverso;

            //Si se trata de una edición de modelo, activo el RB de la opción correspondiente, sino se deja el valor por default
            radioButtons.rbMarca             = action.datosPantalla.marcaEdicion             ? action.datosPantalla.marcaEdicion             : radioButtons.rbMarca;
            radioButtons.rbMoneda            = action.datosPantalla.monedaEdicion            ? action.datosPantalla.monedaEdicion            : radioButtons.rbMoneda;
            radioButtons.rbTipoSucursal      = action.datosPantalla.tipoSucursalEdicion      ? action.datosPantalla.tipoSucursalEdicion      : radioButtons.rbTipoSucursal;
            radioButtons.rbTipoConsolidacion = action.datosPantalla.tipoConsolidacionEdicion ? action.datosPantalla.tipoConsolidacionEdicion : radioButtons.rbTipoConsolidacion;

            //Si se trata de una edición de modelo, selecciono la opción correspondiente del combo, sino se deja el valor por default
            combos.comboSucursal          = action.datosPantalla.sucursalEdicion          ? action.datosPantalla.sucursalEdicion          : 0;
            combos.modalAltaEdicionRenglonContable.comboCentroDeCosto = action.datosPantalla.centroDeCostosActivos;

            result = {
                ...state,
                cuentasContables: action.datosPantalla.cuentasContables,
                modelosContables: action.datosPantalla.modelosContables,
                modelosContablesActivos: action.datosPantalla.modelosActivos,
                inputsABMModelos: inputs,
                checksABMModelos: checks,
                radioButtonsABMModelos: radioButtons,
                combosABMModelos: combos,
                modeloEdicion: action.datosPantalla.modeloEdicion,
                datosPantalla: action.datosPantalla.datosPantallaEdicion.datosPantalla,
                datosRenglones: action.datosPantalla.datosPantallaEdicion.datosPantalla,
                criteriosRenglon: action.datosPantalla.datosPantallaEdicion.criteriosRenglon,
                sugerenciaModelo: action.datosPantalla.sugerenciaModelo,
                marcasActivas: action.datosPantalla.marcasActivas,
                sucursalesActivas: action.datosPantalla.sucursalesActivas,
                monedasActivas: action.datosPantalla.monedasActivas,
                indicadoresInterfazActivos: action.datosPantalla.indicadoresInterfazActivos,
                datosRenglonesExcel: action.datosPantalla.datosRenglonesExcel,
                datosMakerChecker : action.datosMakerChecker
            }
        }
        break;


        case ABMMODELOS_FILTRAR_CUENTAS: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let modeloEdicion = Boolean(state.modeloEdicion);
            let inputs = JSON.parse(JSON.stringify(state.inputsABMModelos));
            let checks = JSON.parse(JSON.stringify(state.checksABMModelos));

            inputs[action.seccionInput][action.nombreInput] = action.valorInput;

            if(action.nombreInput == "inputReemplazarCuenta") {
                inputs[action.seccionInput].cuentasContablesFiltradasReemplazarCuenta = action.cuentasContablesFiltradosBuscador;

                //Si se borra el valor ingresado en el input de "inputReemplazarCuenta", se reinician los valores de los inputs posteriores y se inhabilitan
                if(action.valorInput == "") {
                    inputs[action.seccionInput].inputReemplazarCon = action.valorInput;
                    inputs[action.seccionInput].cuentasSeleccionadas.inputReemplazarCon = "";
                    inputs[action.seccionInput].modelosSeleccionados = checks[action.seccionInput].checkReemplazarEnOtrosModelos && !modeloEdicion ? inputs[action.seccionInput].modelosSeleccionados : [];
                    //En el caso de tratarse de un alta de modelo, se dejará por defecto el check tildado
                    checks[action.seccionInput].checkReemplazarEnOtrosModelos = checks[action.seccionInput].checkReemplazarEnOtrosModelos && !modeloEdicion ? checks[action.seccionInput].checkReemplazarEnOtrosModelos : false;
                }
            } 
            
            if(action.nombreInput == "inputReemplazarCon") {
                inputs[action.seccionInput].cuentasContablesFiltradasReemplazarCon = action.cuentasContablesFiltradosBuscador;

                //Si se borra el valor ingresado en el input de "inputReemplazarCon", se reinician los valores del input del buscador de modelos y se inhabilita
                if(action.valorInput == "") {
                    inputs[action.seccionInput].modelosSeleccionados = checks[action.seccionInput].checkReemplazarEnOtrosModelos && !modeloEdicion ? inputs[action.seccionInput].modelosSeleccionados : [];
                    //En el caso de tratarse de un alta de modelo, se dejará por defecto el check tildado
                    checks[action.seccionInput].checkReemplazarEnOtrosModelos = checks[action.seccionInput].checkReemplazarEnOtrosModelos && !modeloEdicion ? checks[action.seccionInput].checkReemplazarEnOtrosModelos : false;
                }
            }
            if (action.seccionInput == "modalAltaEdicionRenglonContable") {
                inputs[action.seccionInput].cuentasContablesFiltradas = action.cuentasContablesFiltradosBuscador;
            }

            //Al borrar o volver a ingresar un valor, se reinicia el valor del contenedor de la cuenta seleccionada del input correspondiente
            inputs[action.seccionInput].cuentasSeleccionadas[action.nombreInput] = "";

            result = {
                ...state,
                inputsABMModelos: inputs,
                checksABMModelos: checks
            }
        }
        break;


        case ABMMODELOS_CAMBIAR_CHECK: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let checks = JSON.parse(JSON.stringify(state.checksABMModelos));
            let inputs = JSON.parse(JSON.stringify(state.inputsABMModelos));

            checks[action.nombreModal][action.nombreCheck] = action.valor;

            if(!action.valor) {
                //Si se destilda el check, borro el array de modelos seleccionados para no arrastrar información que no corresponde
                inputs[action.nombreModal].modelosSeleccionados = [];
            }

            result = {
                ...state,
                inputsABMModelos: inputs,
                checksABMModelos: checks
            }
        }
        break;
        
        case ABMMODELOS_CARGAR_CUENTAS_CONTABLES_FILTRADAS: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let inputs = JSON.parse(JSON.stringify(state.inputsABMModelos));
            //Se verifica que seccion es
            if(action.seccionRB == "modalCopiarRenglonContable"){
                inputs.modalCopiarRenglonContable.cuentasContablesFiltradas = action.cuentasFiltradas
            }
            if(action.seccionRB == "modalAltaEdicionRenglonContable"){
                inputs.modalAltaEdicionRenglonContable.cuentasContablesFiltradas = action.cuentasFiltradas
            }
            result = {
                ...state,
                inputsABMModelos: inputs,
            
            }
        }
        break;

        case ABMMODELOS_INPUT_ACTIVO: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let inputActivo = JSON.parse(JSON.stringify(state.inputsABMModelos));

            inputActivo[action.seccionInput].inputActivo = action.nombreInput;

            if(action.nombreInput == "inputReemplazarCuenta") {
                inputActivo[action.seccionInput].cuentasContablesFiltradasReemplazarCuenta = action.cuentasContablesFiltradosBuscador;
            } 

            if(action.nombreInput == "inputReemplazarCon") {
                inputActivo[action.seccionInput].cuentasContablesFiltradasReemplazarCon = action.cuentasContablesFiltradosBuscador;
            }

            if(action.nombreInput == "inputReemplazarCon") {
                inputActivo[action.seccionInput].cuentasContablesFiltradas = action.cuentasContablesFiltradosBuscador;
            }


            result = {
                ...state,
                inputsABMModelos: inputActivo
            }
        }
        break;


        case ABMMODELOS_GUARDAR_VALOR_INPUT_SELECCIONADO: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let inputActivo = JSON.parse(JSON.stringify(state.inputsABMModelos));
            let errores = JSON.parse(JSON.stringify(state.errorValidacion));

            if (action.seccionInput == "modalCopiarRenglonContable") {
                errores.modalCopiarRenglonContable.inputCuentaContable = "";
            }
            if (action.seccionInput == "modalAltaEdicionRenglonContable" && action.nombreInput == "inputCuentaContable" && action.valorInput != "") {
                errores.modalAltaEdicionRenglonContable.inputCuentaContable = "";
            }
            inputActivo[action.seccionInput][action.nombreInput] = action.descripcionInput.length > 45 ? action.descripcionInput.substr(0, 45) + String.fromCharCode(8230) : action.descripcionInput;
            inputActivo[action.seccionInput].cuentasSeleccionadas[action.nombreInput] = action.valorInput;

           
            result = {
                ...state,
                inputsABMModelos: inputActivo,
                errorValidacion: errores
            }
        }
        break;


        case ABMMODELOS_REINICIAR_VALORES_MODAL: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let esEdicion = Boolean(state.modeloEdicion);
            let inputActivo = JSON.parse(JSON.stringify(state.inputsABMModelos));
            let checks = JSON.parse(JSON.stringify(state.checksABMModelos));
            let radioButtons = JSON.parse(JSON.stringify(state.radioButtonsABMModelos));
            let errores = JSON.parse(JSON.stringify(state.errorValidacion));
            let combos = JSON.parse(JSON.stringify(state.combosABMModelos));

            if(inputActivo[action.nombreModal]) {
                inputActivo[action.nombreModal] = initialState.inputsABMModelos[action.nombreModal];
            }

            if(action.nombreModal == "modalReemplazarCuentasContables"){
                checks[action.nombreModal].checkReemplazarEnOtrosModelos = esEdicion ? initialState.checksABMModelos[action.nombreModal].checkReemplazarEnOtrosModelos : true;
            } else {
                if(checks[action.nombreModal]) {
                    checks[action.nombreModal] = esEdicion ? initialState.checksABMModelos[action.nombreModal] : true;
                }

                if(radioButtons[action.nombreModal]) {
                    radioButtons[action.nombreModal] = initialState.radioButtonsABMModelos[action.nombreModal];
                }
            }
       
            if (action.nombreModal == "modalCopiarRenglonContable") {
                errores.modalCopiarRenglonContable.inputNumeroRenglon = "";
                errores.modalCopiarRenglonContable.inputCuentaContable = "";
              } else {
                if (errores[action.nombreModal]) {
                 errores[action.nombreModal] = "";
              }
            } 
            if(action.nombreModal == "modalAltaEdicionRenglonContable"){

                inputActivo.modalAltaEdicionRenglonContable= {
                    inputCuentaContable: "",   
                    inputActivo: "", 
                    inputDescripcion : "",                              
                    inputReferenciaRenglon: "",
                    cuentasContablesFiltradas: [], 
                    cuentasSeleccionadas:{          
                        inputCuentaContable:"",
                    },
                };
                radioButtons.modalAltaEdicionRenglonContable={
                    rbTipoApertura: 1, 
                    rbTipoRenglon: 1,
                    rbReferenciaRenglon: 0, 
                    rbTipoOperacion: 1,
                    rbMonedaSalida: "P",
                    rbSignoImporte: "A"
                }

                combos.modalAltaEdicionRenglonContable= {           
                    comboCentroCostoSeleccionado:"0",
                    comboTipoMovimientoSeleccionado:"",
                    comboCampoImporteSeleccionado:"",
                    comboTiposMovimientos:[],
                    contenedorCombosCriteriosContables:[],
                    comboCentroDeCosto: combos.modalAltaEdicionRenglonContable.comboCentroDeCosto
                } 
                
                errores.modalAltaEdicionRenglonContable= initialState.errorValidacion.modalAltaEdicionRenglonContable;
            }       
                result = {
                ...state,
                inputsABMModelos: inputActivo,
                checksABMModelos: checks,
                combosABMModelos: combos,
                radioButtonsABMModelos: radioButtons,
                errorValidacion: errores
            }
        }
        break;


        case ABMMODELOS_FILTRAR_MODELOS: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let inputs = JSON.parse(JSON.stringify(state.inputsABMModelos));

            inputs.modalReemplazarCuentasContables.inputModelos = action.valorInput;
            inputs.modalReemplazarCuentasContables.modelosContablesFiltrados = action.modelosFiltradosBuscador;

            result = {
                ...state,
                inputsABMModelos: inputs
            }
        }
        break;


        case ABMMODELOS_GUARDAR_QUITAR_MODELO_SELECCIONADO: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let inputs = JSON.parse(JSON.stringify(state.inputsABMModelos));
            let modelos = JSON.parse(JSON.stringify(state.modelosContablesActivos));

            //En el caso de estar editando un modelo, se quita del buscador de modelos del modal de "Reemplazar cuentas contables"
            modelos = modelos.filter(m => m.Codigo != state.modeloEdicion)
            

            if(action.adicionarModelo) {
                if(action.modeloSeleccionado == "Todos") {
                    //Solo adiciono el código "Todos"
                    inputs[action.seccionInput].modelosSeleccionados = [{Codigo: action.modeloSeleccionado}];
                } else {
                    inputs[action.seccionInput].modelosSeleccionados.push(action.modeloSeleccionado);
                }
            } else {
                if(action.modeloSeleccionado == "Todos") {
                    //Si se selecciona el valor "Todos" se borra el array de modelos seleccionados
                    inputs[action.seccionInput].modelosSeleccionados = [];
                    //Se modifica al array de modelos filtrados para agregar nuevamente el valor "Todos" junto con todos los modelos
                    inputs[action.seccionInput].modelosContablesFiltrados = [{Codigo: action.modeloSeleccionado}, ...modelos];

                    inputs[action.seccionInput].mostrarVerMas = true;
                } else {
                    //Si hasta este momento la cantidad de modelos seleccionados es 10, quiere decir que será de 9, con lo cual reactivo el botón de "Ver más" para el caso de que se vuelva a agregar más modelos adelante
                    if(inputs[action.seccionInput].modelosSeleccionados.length == 10) {
                        inputs[action.seccionInput].mostrarVerMas = true;
                    }
                    
                    inputs[action.seccionInput].modelosSeleccionados = inputs[action.seccionInput].modelosSeleccionados.filter(m => { return m.Codigo != action.modeloSeleccionado.Codigo });
                    //Se modifica el array de modelos filtrados para el caso de que si el dropdown del buscador de modelos esté activo y se quite uno de los modelos seleccionados, se vuelva a visualizar ese modelo en el dropdown y se ordena por código.
                    inputs[action.seccionInput].modelosContablesFiltrados = [...inputs[action.seccionInput].modelosContablesFiltrados, modelos.filter(m => m.Codigo == action.modeloSeleccionado.Codigo)[0]].sort((a,b) => a.Codigo - b.Codigo);
                }
            }

            result = {
                ...state,
                inputsABMModelos: inputs
            }
        }
        break;


        case ABMMODELOS_INPUT_ACTIVO_BUSCADOR_MODELOS: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let inputModelo = JSON.parse(JSON.stringify(state.inputsABMModelos));

            inputModelo.modalReemplazarCuentasContables.inputActivo = action.nombreInput;

            inputModelo.modalReemplazarCuentasContables.modelosContablesFiltrados = action.modelosFiltradosBuscador;
            
            result = {
                ...state,
                inputsABMModelos: inputModelo
            }
        }
        break;


        case ABMMODELOS_MOSTRAR_SPINNER: {
            let nombreSpinner = action.spinner ? action.spinner : "mostrarSpinnerABMModelos";

            result = {
                ...state,
                [nombreSpinner]: action.valor
            }
        }
        break;

        
        case ABMMODELOS_OCULTAR_BOTON_VERMAS: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let input = JSON.parse(JSON.stringify(state.inputsABMModelos));

            input.modalReemplazarCuentasContables.mostrarVerMas = false;

            result = {
                ...state,
                inputsABMModelos: input
            }
        }
        break;


        case ROUTE_TO_MODELOS_CONTABLES: {
            result = {
                ...state,
                redirect: {
                    shouldRedirect: true,
                    to: action.data
                }
            }
        }
        break;


        case ABMMODELOS_CARGAR_PERMISOS_USUARIO: {
            result = {
                ...state,
                permisosUsuario: action.permisos
            }
        }
        break;


        case ABMMODELOS_CAMBIAR_CHECK_PANTALLA_PRINCIPAL: {
            //Se utiliza esta forma de copiar el valor ya que se puede hacer una copia "profunda" (deep copy) del objeto y no una copia por referencia (shallow copy)
            let checks = JSON.parse(JSON.stringify(state.checksABMModelos));

            checks[action.nombreCheck] = action.valor;

            result = {
                ...state,
                checksABMModelos: checks
            }
        }
        break;


        case ABMMODELOS_SELECCIONAR_RB: {
            let radioButtons = JSON.parse(JSON.stringify(state.radioButtonsABMModelos));
            let input = JSON.parse(JSON.stringify(state.inputsABMModelos));
            let errores = JSON.parse(JSON.stringify(state.errorValidacion));

            if(action.seccionRB) {
                radioButtons[action.seccionRB][action.nombreRB] = action.valorRB;

                if(action.seccionRB == "modalCopiarRenglonContable" && action.nombreRB == "rbUbicacionRenglon") {
                    input.modalCopiarRenglonContable.inputNumeroRenglon = "";
                    errores.modalCopiarRenglonContable.inputNumeroRenglon = "";
                }
            } else {
                radioButtons[action.nombreRB] = action.valorRB;
            }

            result = {
                ...state,
                radioButtonsABMModelos: radioButtons,
                inputsABMModelos: input,
                errorValidacion: errores
            }
        }
        break;

        
        case ABMMODELOS_LIMPIEZA_CUENTA_SELECCIONADA: {
            let inputs = JSON.parse(JSON.stringify(state.inputsABMModelos));
           
            //Al borrar o volver a ingresar un valor, se reinicia el valor del contenedor de la cuenta seleccionada del input correspondiente
            if (action.borrarCuentaSeleccionada && action.seccionInput == "modalCopiarRenglonContable") {
                inputs[action.seccionInput][action.nombreInput] = action.valorInput;
                inputs.modalCopiarRenglonContable.cuentasSeleccionadas.inputCuentaContable =  "";
            }
            if (action.borrarCuentaSeleccionada && action.seccionInput == "modalAltaEdicionRenglonContable") {
                inputs[action.seccionInput][action.nombreInput] = action.valorInput;
                inputs.modalAltaEdicionRenglonContable.cuentasSeleccionadas.inputCuentaContable =  action.valorInput;
            }
            result = {
              ...state,
              inputsABMModelos: inputs,
            };
        }
        break;


        case ABMMODELOS_SELECCIONAR_OPCION_COMBO: {
            let combos = JSON.parse(JSON.stringify(state.combosABMModelos));
            let checks = JSON.parse(JSON.stringify(state.checksABMModelos));

            

            if (action.nombreCombo == "comboCentroCostoSeleccionado") {
                   combos.modalAltaEdicionRenglonContable[action.nombreCombo] = action.valorCombo;
            }
            if (action.nombreCombo == "comboTipoMovimientoSeleccionado") {
                combos.modalAltaEdicionRenglonContable[action.nombreCombo] = action.valorCombo;
            }
            if (action.nombreCombo == "comboCampoImporteSeleccionado") {
                combos.modalAltaEdicionRenglonContable[action.nombreCombo] = action.valorCombo;
            }
            else combos[action.nombreCombo] = action.valorCombo;

            if(action.nombreCombo == "comboSucursal") {
                //Reinicio valor del checkbox de "Apertura por socio" en caso de cambiar el valor de "Todas"
                checks.checkAperturaPorSucursal = false;
            }

            result = {
                ...state,
                combosABMModelos: combos,
                checksABMModelos: checks
            }
        }
        break;


        case ABMMODELOS_CAMBIAR_VALOR_INPUT: {
            let input = JSON.parse(JSON.stringify(state.inputsABMModelos));

            if(action.seccionInput) {
                input[action.seccionInput][action.nombreInput] = action.valorInput;
            } else {
                input[action.nombreInput] = action.valorInput;
            }

            result = {
                ...state,
                inputsABMModelos: input
            }
        }
        break;
  
        case ABMMODELOS_ACTUALIZAR_OPCION_ELEGIDA: {
            }
            result = {
                ...state,
                opcionElegida: action.opcionElegida
            }
        break;


        case ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR: {
            let errores = JSON.parse(JSON.stringify(state.errorValidacion));

          
            if (action.nombre == "modalCopiarRenglonContable") {
                errores.modalCopiarRenglonContable.inputNumeroRenglon = action.valor;
                errores.modalCopiarRenglonContable.inputCuentaContable = action.valor;
               
               } else {
           errores[action.nombre] = action.valor;
        }
            result = {
                ...state,
                errorValidacion: errores
            }
        }
        break;

        case ABMMODELOS_CAMBIAR_VALOR_VALIDACION_ERROR_POR_NOMBRE: {

            let errores = JSON.parse(JSON.stringify(state.errorValidacion));

            errores[action.seccion][action.nombre] = "";

                result = {
                    ...state,
                    errorValidacion: errores
                }
        }
        break;

        case ABMMODELOS_VALIDAR_FORMULARIO: {
            result = {
                ...state,
                errorValidacion: action.erroresValidacion
            }
        }
        break;


        case ABMMODELOS_CAMBIAR_RENGLON_BOTON_DESPLEGABLE: {
            let valor = action.valorDesplegable ? action.idRenglon : null;

            result = {
                ...state,
                registroDesplegado: valor
            }
        }
        break;

        case ABMMODELOS_ACTUALIZAR_PANTALLA_ABMMODELOS: {
            result = {
                ...state,
                datosPantalla: action.datosPantalla
            }
        }
        break;


        case ABMMODELOS_AGREGAR_ELIMINAR_RENGLON_CONTABLE: {
            result = {
                ...state,
                datosRenglones: action.datosRenglones,
                criteriosRenglon: action.datosCriterios
            }
        }
        break;


        case ABMMODELOS_MOSTRAR_INPUT_IMPORTAR_MODELOS: {
            result = {
                ...state,
                seImportaModelo: action.valor
            }
        }
        break;


        case ABMMODELOS_FILTRAR_MODELOS_IMPORTAR: {
            result = {
                ...state,
                inputsABMModelos: action.inputs
            }
        }
        break;


        case ABMMODELOS_MOSTRAR_RESULTADOS_IMPORTAR_MODELOS: {
            result = {
                ...state,
                inputsABMModelos: action.inputs
            }
        }
        break;


        case ABMMODELOS_IMPORTAR_MODELO: {
            result = {
                ...state,
                datosPantalla: action.datosImportados.datosPantalla,
                datosRenglones: action.datosImportados.datosPantalla,
                criteriosRenglon: action.datosImportados.criteriosRenglon,
                inputsABMModelos: action.inputs,
                checksABMModelos: action.checks,
                radioButtonsABMModelos: action.radioButtons,
                combosABMModelos: action.combos,
                datosRenglonesExcel: action.datosRenglonesExcel
            }
        }
        break;


        case ABMMODELOS_MOSTRAR_RESULTADOS_INDICADOR_INTERFAZ: {
            result = {
                ...state,
                inputsABMModelos: action.inputs
            }
        }
        break;


        case ABMMODELOS_FILTRAR_INDICADORES_INTERFAZ: {
            result = {
                ...state,
                inputsABMModelos: action.inputs,
                errorValidacion : action.errorValidacion
            }
        }
        break;


        case ABMMODELOS_GUARDAR_CANTIDADES_REEMPLAZADAS: {
            result = {
                ...state,
                cantidadRenglones: action.cantidadRenglones,
                cantidadModelos: action.cantidadModelos
            }
        }
        break;


        case ABMMODELOS_GUARDAR_DATOS_SAGA_REEMPLAZAR_CUENTA: {
            let errores = JSON.parse(JSON.stringify(state.errorValidacion));

            errores.modalResultadoReemplazarCuentasContables = action.huboError;

            result = {
                ...state,
                errorValidacion: errores,
                sagaId: action.sagaId
            }
        }
        break;


        case ABMMODELOS_ACTUALIZAR_RENGLONES: {
            result = {
                ...state,
                datosRenglones: action.renglones
            }
        }
        break;

        case ABMMODELOS_ACTUALIZAR_CRITERIOS: {
            result = {
                ...state,
                criteriosRenglon: action.criterios
            }
        }
        break;

        case ABMMODELOS_ACTUALIZAR_DATOSEXCEL: {
            result = {
                ...state,
                datosRenglonesExcel: action.datosExcelFinal
            }
        }
        break;


        case ABMMODELOS_ACTUALIZAR_VALORES_MODAL_ALTA_EDICION_RENGLON: {
            let inputs = JSON.parse(JSON.stringify(state.inputsABMModelos));

            inputs.modalAltaEdicionRenglonContable.cuentasContablesFiltradas = action.cuentasFiltradas;
            result = {
                ...state,
                inputsABMModelos: inputs
            }
        }
        break;


        case ABMMODELOS_ACTUALIZAR_VALORES_MODAL_COPIAR_RENGLON: {
            let inputs = JSON.parse(JSON.stringify(state.inputsABMModelos));
            let radios = JSON.parse(JSON.stringify(state.radioButtonsABMModelos));

            inputs.modalCopiarRenglonContable.cuentasContablesFiltradas = action.cuentasFiltradas;
            inputs.modalCopiarRenglonContable.renglon = action.renglon;
            inputs.modalCopiarRenglonContable.criterios = action.criterios;
            radios.modalCopiarRenglonContable.mostrarSignoAmbos = action.mostrarSignoAmbos;
            radios.modalCopiarRenglonContable.rbSignoImporte = action.renglon.SignoCampo == "+" ? "P" : action.renglon.SignoCampo == "-" ? "N" : "A";
            radios.modalCopiarRenglonContable.rbTipoOperacion = action.renglon.TipoOperacion == 1 ? 'D' : 'C';
            result = {
                ...state,
                inputsABMModelos: inputs,
                radioButtonsABMModelos: radios
            }
        }
        break;


        case ABMMODELOS_AGREGAR_RENGLON: {
            result = {
                ...state,
                datosRenglones: action.renglones,
                criteriosRenglon: action.criterios,
                referenciaRenglonCopia: action.referenciaRenglonCopia,
                registroDesplegado: null
            }
        }
        break;


        case ABMMODELOS_FILTRAR_CUENTAS_COPIAR_RENGLON: {
            let inputs = JSON.parse(JSON.stringify(state.inputsABMModelos));

            inputs[action.seccionInput][action.nombreInput] = action.valorInput;

            inputs[action.seccionInput].cuentasContablesFiltradas = action.cuentasContablesFiltradosBuscador;

             //Al borrar o volver a ingresar un valor, se reinicia el valor del contenedor de la cuenta seleccionada del input correspondiente
             inputs[action.seccionInput].cuentasSeleccionadas[action.nombreInput] = "";

            result = {
                ...state,
                inputsABMModelos: inputs
            }
        }
        break;

        case ABMMODELOS_TIPOS_MOVIMIENTO: {
            let combos = JSON.parse(JSON.stringify(state.combosABMModelos));
            combos.modalAltaEdicionRenglonContable.comboTiposMovimientos = action.tiposMovimiento;

            result = {
                ...state,
                combosABMModelos: combos
            }
        }
        break;

        case ABMMODELOS_CARGAR_CAMPO_IMPORTE: {
            let combos = JSON.parse(JSON.stringify(state.combosABMModelos));

            combos.modalAltaEdicionRenglonContable.comboCampoImporte = action.valoresCampoImporte;

            result = {
                ...state,
                combosABMModelos: combos
            }
        }
        break;

        case ABMMODELOS_CARGAR_COMBOS_CRITERIOS_CONTABLES: {
            let combos = JSON.parse(JSON.stringify(state.combosABMModelos));

            combos.modalAltaEdicionRenglonContable.contenedorCombosCriteriosContables = action.arrayContenedor;

            result = {
                ...state,
                combosABMModelos: combos
            }
        }
        break;
        
        case ABMMODELOS_AGREGAR_QUITAR_OPCIONES_SELECTORES: {
            // let combos = JSON.parse(JSON.stringify(state.combosABMModelos));

            let combos = action.combos;

            result = {
                ...state,
                combosABMModelos: combos
            }
        }
        break;

        case ABMMODELOS_ACTUALIZAR_VALIDACION_ERROR: {
            result = {
                ...state,
                errorValidacion: action.errores
            }
        }
        break;


        case ABMMODELOS_MOSTRAR_MODAL_MENSAJE_RESULTADO: {
            result = {
                ...state,
                modalMensajeResultado: action.mensaje,
                redireccionarPantallaPrincipal: action.redireccionarPantallaPrincipal
            }
        }
        break;


        case ABMMODELOS_ACTUALIZAR_DATOS_CONFIRMACION: {
            result = {
                ...state,
                datosPantalla: action.dataConfirmacion
            }
        }
        break;


        case ABMMODELOS_RENGLON_EDICION: {
            result = {
                ...state,
                renglonEdicion: action.renglon
            }
        }
        break;


        case ABMMODELOS_ACTUALIZAR_MENSAJE_RENGLONES_IGUALES: {
            result = {
                ...state,
                mensajeValidacionRenglonesIguales: action.mensaje
            }
        }
        break;


        default:
            result = {
                ...state
            };
        break;

    }

    LogHelper.Out(abmModelos.name, result);

    return result;
}


export default abmModelos;